import { useEffect, useState } from 'react';
import { Route, RouteProps, RouteComponentProps } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import LoaderGlobal from 'components/Loader/LoaderApp/LoaderGlobal';
import ModalExperiencia from 'components/ModalExperiencia';

import { loadUserAndPermissions } from '../services/Auth/AuthService';
import SnackbarUtils from '../utils/SnackbarUtils';
import userManager from 'services/Auth/oidc.config';
import { pathRegistraLogin } from 'services/projeto';

interface PrivateRouteProps extends RouteProps {
  component?: React.ComponentType<RouteComponentProps<any>>;
}

export function PrivateRoute({
  component: Component,
  ...rest
}: PrivateRouteProps) {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    const clearSession = async () => {
      await userManager.removeUser();
      await userManager.clearStaleState();
    };

    const redirectToLogin = async () => {
      await userManager.signinRedirect({
        extraQueryParams: { prompt: 'login' },
      });
    };

    const checkAuthentication = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const hasCode = urlParams.has('code');
      const hasState = urlParams.has('state');

      try {
        if (hasCode && hasState) {
          await userManager.signinRedirectCallback();

          try {
            await pathRegistraLogin();
          } catch (err) {
            console.error('Erro ao registrar login', err);
          }

          window.history.replaceState(
            {},
            document.title,
            window.location.pathname
          );
        }

        const user = await userManager.getUser();

        if (!user || user.expired) {
          await redirectToLogin();
          return;
        }

        try {
          await userManager.signinSilent();
          await dispatch(loadUserAndPermissions());

          setIsAuthenticated(true);
        } catch (silentErr) {
          await clearSession();

          localStorage.clear();
          sessionStorage.clear();

          await userManager.signoutRedirect({
            id_token_hint: user.id_token,
            post_logout_redirect_uri: window.env.auth.redirectUrl,
          });

          return;
        }
      } catch (error) {
        SnackbarUtils.enqueueSnackbar({
          message: 'Sessão inválida. Redirecionando...',
          options: { variant: 'error' },
        });

        await clearSession();
        await redirectToLogin();

        return;
      } finally {
        setIsLoading(false);
      }
    };

    checkAuthentication();
  }, [dispatch]);

  const renderFn = (props: RouteComponentProps<any>) => {
    if (isLoading) {
      return (
        <div className="container">
          <LoaderGlobal />
        </div>
      );
    }

    if (isAuthenticated && Component) {
      return (
        <>
          <Component {...props} />
          <ModalExperiencia />
          {/* <ModalAviso /> */}
        </>
      );
    }

    return null;
  };

  return <Route {...rest} render={renderFn} />;
}